<template>
  <div class="field-group" v-if="active" :key="fieldId">
    <slot />
  </div>
</template>
<script>
export default {
  name: "field-group",
  props: ["fieldId"],
  inject: ["formState"],
  computed: {
    active() {
      return this.formState.activeField === this.fieldId;
    },
    isNext() {
      return this.formState.isNext;
    }
  }
};
</script>